export default "__VITE_PUBLIC_ASSET__f830a321__"